'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { authBus } from '@/lib/auth-bus';
import { useTranslation } from '@/hooks/useTranslation';
import { appendInviteCodeToPath, getInviteCodeFromWindowLocation } from '@/lib/inviteCode';

export function UnauthorizedDialog() {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleUnauthorized = () => {
      setOpen(true);
    };

    authBus.onUnauthorized(handleUnauthorized);
    return () => {
      authBus.offUnauthorized(handleUnauthorized);
    };
  }, []);

  const handleRelogin = () => {
    setOpen(false);
    const currentPath =
      typeof window === 'undefined'
        ? '/'
        : `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const params = new URLSearchParams({ redirect: currentPath || '/' });
    router.push(appendInviteCodeToPath(`/login?${params.toString()}`, getInviteCodeFromWindowLocation()));
  };

  const handleGoHome = () => {
    setOpen(false);
    router.push('/');
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        className="!min-w-0 w-[calc(100%-2rem)] sm:w-full sm:max-w-[400px]"
        showCloseButton={false}
      >
        <DialogHeader>
          <DialogTitle>{t('unauthorizedDialog.title')}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground py-4">
          {t('unauthorizedDialog.description')}
        </p>
        <DialogFooter>
          <Button variant="outline" onClick={handleGoHome}>
            {t('unauthorizedDialog.goHome')}
          </Button>
          <Button color="primary" onClick={handleRelogin}>
            {t('unauthorizedDialog.relogin')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
